import { render, staticRenderFns } from "./OverviewMilvaMarket.vue?vue&type=template&id=27ffd4c4&scoped=true&"
import script from "./OverviewMilvaMarket.vue?vue&type=script&lang=js&"
export * from "./OverviewMilvaMarket.vue?vue&type=script&lang=js&"
import style0 from "./OverviewMilvaMarket.vue?vue&type=style&index=0&id=27ffd4c4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ffd4c4",
  null
  
)

export default component.exports